import React, { useState, useContext, useEffect } from "react";
import { SketchPicker } from 'react-color';

import "../CommandPalette/CommandPalette.css"
import controlContext from "../../contexts/control-context";
import curvedline from "../../assets/curved-line.png";


const CommandPalette = (props) => {
    const {
        currMode,
        currFillColor,
        changeCurrFillColor,
        currBorderColor,
        changeCurrBorderColor,
        currBorderWidth,
        changeCurrBorderWidth,
        currFontFamily,
        changeCurrFontFamily,
        currFontSize,
        changeCurrFontSize,
        selectedShapeId,
        shapesMap,
        inputMoveShape,
        deleteSelectedShape,
        addFrameInteraction,
        selectedFrameId,
        framesMap,
        frames,
        currFrameInteraction
    } = useContext(controlContext);

    const [visible, setVisible] = React.useState("fill");
    const [hidePalette, setHidePalette] = React.useState(false)

    useEffect(() => {
        if (currMode === "line" || (selectedShapeId !== undefined && shapesMap[selectedShapeId].type === "line")) setVisible("stroke"); 
        if (currMode === "text" || (selectedShapeId !== undefined && shapesMap[selectedShapeId].type === "text")) setVisible("fill"); 
    }, [currMode, selectedShapeId, shapesMap])

    
    const Plot = () => {

        const [xval, setXval] = useState(selectedShapeId == null ? "" : shapesMap[selectedShapeId].initCoords.x);
        const [yval, setYval] = useState(selectedShapeId == null ? "" : shapesMap[selectedShapeId].initCoords.y);
        const [width, setWidth] = useState(selectedShapeId == null ? "" : Math.abs((shapesMap[selectedShapeId].finalCoords.x - shapesMap[selectedShapeId].initCoords.x)));
        const [height, setHeight] = useState(selectedShapeId == null ? "" : Math.abs((shapesMap[selectedShapeId].finalCoords.y - shapesMap[selectedShapeId].initCoords.y)));


        return (
            <div className="plot">
                <h3>{getTitle(currMode)}</h3>
                <div>
                    <label className="plot-label">
                        <span>X:</span>
                        <input className="plot-input" type="text"
                        value={xval}
                        onChange={(e) => setXval(e.target.value)}
                        onKeyDown={(e) =>
                            { 
                                if (e.key === "Enter") {

                                    inputMoveShape(
                                        // oldData
                                        {
                                            initCoords: {
                                                x: shapesMap[selectedShapeId].initCoords.x,
                                                y: shapesMap[selectedShapeId].initCoords.y,
                                              },
                                              finalCoords: {
                                                x: shapesMap[selectedShapeId].finalCoords.x,
                                                y: shapesMap[selectedShapeId].finalCoords.y,
                                              }
                                        },
                                        // newData
                                        {
                                            initCoords: {
                                                x: parseInt(xval),
                                                y: shapesMap[selectedShapeId].initCoords.y,
                                            },
                                            finalCoords: {
                                                x: parseInt(xval) + (shapesMap[selectedShapeId].finalCoords.x - shapesMap[selectedShapeId].initCoords.x),
                                                y: shapesMap[selectedShapeId].finalCoords.y,
                                            }
                                        }

                                    )
                            }
                        }}
                        ></input>
                    </label>
                    <label className="plot-label">
                        <span>Y:</span>
                        <input className="plot-input" type="text" 
                        value={yval}
                        onChange={(e) => { setYval(e.target.value); console.log(yval);}}
                        onKeyDown={(e) =>
                            { if (e.key === "Enter") {

                                inputMoveShape(
                                    // oldData
                                    {
                                        initCoords: {
                                            x: shapesMap[selectedShapeId].initCoords.x,
                                            y: shapesMap[selectedShapeId].initCoords.y,
                                          },
                                          finalCoords: {
                                            x: shapesMap[selectedShapeId].finalCoords.x,
                                            y: shapesMap[selectedShapeId].finalCoords.y,
                                          }
                                    },
                                    // newData
                                    {
                                        initCoords: {
                                            x: shapesMap[selectedShapeId].initCoords.x,
                                            y: parseInt(yval),
                                        },
                                        finalCoords: {
                                            x: shapesMap[selectedShapeId].finalCoords.x,
                                            y: parseInt(yval) + (shapesMap[selectedShapeId].finalCoords.y - shapesMap[selectedShapeId].initCoords.y),
                                        }
                                    },

                                )

                            }
                        }}
                        ></input>
                    </label><br/>
                    <label className="plot-label">
                        <span>W:</span>
                        <input className="plot-input" type="text" 
                        value={width}
                        onChange={(e) => { setWidth(e.target.value); console.log(width);}}
                        onKeyDown={(e) =>
                            { if (e.key === "Enter") {

                                inputMoveShape(
                                    // oldData
                                    {
                                        initCoords: {
                                            x: shapesMap[selectedShapeId].initCoords.x,
                                            y: shapesMap[selectedShapeId].initCoords.y,
                                          },
                                          finalCoords: {
                                            x: shapesMap[selectedShapeId].finalCoords.x,
                                            y: shapesMap[selectedShapeId].finalCoords.y,
                                          }
                                    },
                                    // newData
                                    {
                                        initCoords: {
                                            x: shapesMap[selectedShapeId].initCoords.x,
                                            y: shapesMap[selectedShapeId].initCoords.y,
                                        },
                                          finalCoords: {
                                            x: shapesMap[selectedShapeId].initCoords.x + parseInt(e.target.value),
                                            y: shapesMap[selectedShapeId].finalCoords.y,
                                        }
                                    },

                                )
                            }
                        }}></input>
                    </label>
                    <label className="plot-label">
                        <span>H:</span>
                        <input className="plot-input" type="text" 
                        value={height}
                        onChange={(e) => { setHeight(e.target.value); console.log(height);}}
                        onKeyDown={(e) =>
                            { if (e.key === "Enter") {

                                inputMoveShape(
                                    // oldData
                                    {
                                        initCoords: {
                                            x: shapesMap[selectedShapeId].initCoords.x,
                                            y: shapesMap[selectedShapeId].initCoords.y,
                                          },
                                          finalCoords: {
                                            x: shapesMap[selectedShapeId].finalCoords.x,
                                            y: shapesMap[selectedShapeId].finalCoords.y,
                                          }
                                    },
                                    // newData
                                    {
                                        initCoords: {
                                            x: shapesMap[selectedShapeId].initCoords.x,
                                            y: shapesMap[selectedShapeId].initCoords.y,
                                        },
                                          finalCoords: {
                                            x: shapesMap[selectedShapeId].finalCoords.x,
                                            y: shapesMap[selectedShapeId].initCoords.y + parseInt(e.target.value),
                                        }
                                    },

                                )
                            }
                        }}></input>
                    </label><br/>
                </div>
            </div>
        )
    };

    const Font = () => {
        const fontFamilies = ["Arial", "sans-serif", "Roboto", "Monospace"];
        const fontSizes = [9, 10, 11, 12, 13, 14, 18, 24, 36, 48, 64, 72, 96, 144, 288];
        return (
            <div className="font">
                <select id="font-families" value={currFontFamily} onChange={(e) => changeCurrFontFamily(e.target.value)}>
                    {fontFamilies.map((font => {
                        return <option value={font} key={font}>{font}</option>
                    }))}
                </select>
                <select id="font-sizes" value={currFontSize} onChange={(e) => changeCurrFontSize(parseInt(e.target.value))}>
                    {fontSizes.map((size) => {
                        return <option value={size} key={size}>{size}</option>
                    })}
                </select>
            </div>
        )
    }

    const Color = () => { 
        let oldVal = null;
        return (
            <div className="color">
                <button className="color-button" onClick={() => setVisible("fill")} 
                        style={{color: visible === "fill" ? "black" : "grey"}}
                        disabled={currMode === "line" || (selectedShapeId !== undefined && shapesMap[selectedShapeId].type === "line")}>Fill</button>
                <button className="color-button" onClick={() => setVisible("stroke")} 
                        style={{color: visible === "stroke" ? "black" : "grey"}}
                        disabled={currMode === "text" || (selectedShapeId !== undefined && shapesMap[selectedShapeId].type === "text")}>Stroke</button>
                { visible === "fill" ? 
                    <div className="color-fill">
                        <SketchPicker className="colorpicker" color={currFillColor} onChangeComplete={(color) => changeCurrFillColor(color.hex)}/>
                    </div> : 
                    null }
                { visible === "stroke" ? 
                    <div className="color-stroke">
                        <SketchPicker className="colorpicker" color={currBorderColor} onChangeComplete={(color) => changeCurrBorderColor(color.hex)}/>
                        <label className="color-label">
                            Stroke width: 
                            <input className="stroke-input" type="range" 
                                min={1} max={30} value={currBorderWidth} style={{ width: 200 }}
                                onChange={(e) => changeCurrBorderWidth(e.target.value)}
                                onMouseDown={() => {
                                    oldVal = currBorderWidth;
                                }}
                                onMouseUp={() => {
                                    if (oldVal !== currBorderWidth) {changeCurrBorderWidth(oldVal, true);}
                                    oldVal = null;
                                }}/>
                            <span>{currBorderWidth}</span>
                        </label>
                    </div> : 
                    null }
                
            </div>
        )
    };

    const Prototyping = () => {

        // console.log(currFrameInteraction)
        // console.log(shapesMap)

        return (
            <div id="prototyping">
                <span>onClick Go to: </span>
                <select id="frames"  
                    value={shapesMap[selectedShapeId].frameInteraction} 
                    onChange={(e) => {addFrameInteraction(e.target.value == "None" ? null : e.target.value);
                                      }}>
                    <option value={undefined}>None</option>
                    {frames.map((frame => {
                        // only allow the visible ones to be chosen
                        if (framesMap[frame].visible && frame !== selectedFrameId){
                            return <option value={frame}>{framesMap[frame].name}</option>
                        }
                    }))}
                </select>
            </div>
        )

    };

    function getTitle(currMode) {
        if (currMode === "select") {
            return "Object"
        } else if (currMode === "rect") {
            return "Rectangle"
        } else if (currMode === "ellipse") {
            return "Ellipse"
        } else if (currMode === "line") {
            return "Line"
        } else {
            return "Text"
        }
    }

    // mousedown event handler for when movement of palette has begun
    function startMovingPalette(e){
        console.log(e.target.id)
        if (e.target.id == "remaining-moveable-section") {
            var cp = document.getElementById("command-palette");
            props.setCp(cp);
            var comstyles = window.getComputedStyle(cp);
            props.setComputedStyles(comstyles);
            // props.setTop(comstyles.getPropertyValue("top"));
            // props.setLeft(comstyles.getPropertyValue("left"));
            props.setTop(e.clientY - cp.offsetTop);
            props.setLeft(e.clientX - cp.offsetLeft);
            props.setIsDragging(true);
        }
    }

    // mouseup event handler for when movement of palette has ended
    function stopMovingPalette(e){
        props.setIsDragging(false);
        console.log(props.isDragging)
    }

    return (
        <div id="command-palette">
            {/* black bar with collapse button */}
            <div id="moveable-section">
                <div id="collapsible" onClick={() => setHidePalette(!hidePalette)}>{hidePalette ? 
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-plus-lg" viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"/>
                    </svg> : 
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-dash-lg" viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M2 8a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 8Z"/>
                    </svg>}</div>
                <div id="remaining-moveable-section" onMouseDown={(e) => startMovingPalette(e)} onMouseUp={(e) => stopMovingPalette(e)}></div>
            </div>
            {/* palette content */}
            {hidePalette ? null :
                <div id="palette-content" onMouseDown={(e) => startMovingPalette(e)} onMouseUp={(e) => stopMovingPalette(e)}>
                    <Plot title={getTitle()}/>
                    {currMode === "text" || (selectedShapeId !== undefined && shapesMap[selectedShapeId].type === "text") ? 
                    <Font/> : null}
                    <Color/>
                    {currMode === "select" && (selectedShapeId !== undefined)  ? 
                        <div>
                            <Prototyping/>
                            <button type="button" id="delete-button" onClick={(e) => deleteSelectedShape()}>Delete Object</button>
                        </div>
                 : null }
                </div>
            }
        </div>
    )

}

export default CommandPalette;